import { defineStyle, defineStyleConfig, cssVar } from '@chakra-ui/react';

const $startColor = cssVar('skeleton-start-color');
const $endColor = cssVar('skeleton-end-color');

const normal = defineStyle({
  _light: {
    [$startColor.variable]: 'colors.neutral.700',
    [$endColor.variable]: 'colors.neutral.300',
  },
  _dark: {
    [$startColor.variable]: 'colors.neutral.700',
    [$endColor.variable]: 'colors.neutral.300',
  },
});
export const skeletonTheme = defineStyleConfig({});
export const Skeleton = defineStyleConfig({
  defaultProps: {
    variant: 'normal',
  },
  variants: { normal },
});
